export interface Article {
  id: string;
  slug: string;
  title: string;
  summary: string;
  content: string;
  coverImage: string;
  categoryId: string;
  categorySlug: string;
  categoryName: string;
  author: string;
  publishDate: string;
  readTime: number;
  tags: string[];
  viewCount: number;
  isFeatured: boolean;
}

export const articles: Article[] = [
  {
    id: 'art-1',
    slug: 'huangguo-gaochan-zaipei-jishu-yaodian',
    title: '黄瓜高产栽培技术要点全解析',
    summary: '掌握科学的黄瓜栽培管理技术，是实现黄瓜高产优质的关键。本文从品种选择、育苗定植到田间管理，全面讲解黄瓜高产栽培核心技术。',
    content: `<p>黄瓜是我国重要的蔬菜作物之一，种植面积广、消费量大。要实现黄瓜高产优质，必须从品种选择、育苗技术、田间管理等多个环节入手，构建科学的栽培管理体系。</p>
<h2>一、品种选择原则</h2>
<p>选择适合当地气候条件和栽培方式的黄瓜品种是获得高产的基础。华北地区宜选择耐低温弱光的品种，华南地区则需选择耐热耐湿的品种。保护地栽培应选择单性结实能力强、耐弱光的品种。</p>
<p>目前市场上表现较好的品种包括：津优系列、中农系列、津春系列等国内优良品种，以及部分进口杂交品种。建议种植户根据当地市场需求，选择商品性好的品种。</p>
<h2>二、育苗技术</h2>
<p>黄瓜育苗是确保齐苗壮苗的关键环节。采用穴盘育苗或营养钵育苗，基质选用草炭、蛭石、珍珠岩按3:1:1比例混合。播种前种子需进行温汤浸种处理，水温55℃浸泡15分钟，可有效杀灭种传病菌。</p>
<p>苗期温度管理：出苗前保持28-30℃，出苗后白天25-28℃，夜间15-18℃。注意通风降湿，防止徒长和病害发生。苗龄一般30-35天，三叶一心时即可定植。</p>
<h2>三、定植与密度</h2>
<p>定植前需深耕整地，每亩施入腐熟有机肥3000-4000公斤，配合复合肥50公斤作基肥。采用高畦栽培，畦宽1.2米，每畦栽两行，株距30-35厘米。保护地栽培每亩定植3000-3500株，露地栽培每亩3500-4000株。</p>
<h2>四、水肥管理</h2>
<p>黄瓜需水量大但不耐涝，应保持土壤湿润但不积水。定植后浇足定根水，缓苗期控制浇水促进根系生长。结瓜期需水量最大，采用膜下滴灌方式，每3-5天灌溉一次。</p>
<p>追肥遵循"少量多次"原则。定植后7-10天追施提苗肥，每亩尿素5-8公斤；结瓜初期追施催瓜肥，每亩复合肥15-20公斤；盛瓜期每10天追肥一次，配合叶面喷施磷酸二氢钾和微量元素。</p>
<h2>五、植株调整</h2>
<p>及时进行吊蔓、整枝、打杈、摘心等植株调整工作。主蔓结瓜品种保留主蔓，侧蔓留1-2片叶摘心；侧蔓结瓜品种主蔓4-5片叶时摘心，促发侧蔓。及时摘除老叶、病叶，改善通风透光条件。</p>
<h2>六、采收管理</h2>
<p>黄瓜以嫩瓜供食，应及时采收。一般开花后8-12天即可采收，根瓜适当早采，促进后续坐瓜。盛瓜期每天或隔天采收一次。采收宜在清晨进行，采后及时预冷处理，保持产品新鲜度。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20cucumber%20greenhouse%20cultivation%20with%20healthy%20vines%20and%20fresh%20cucumbers%20growing%20on%20trellis%2C%20modern%20agricultural%20irrigation%20system%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20photography%20style%2C%20bright%20green%20foliage%20against%20neutral%20background&width=800&height=500&seq=art-cover-01&orientation=landscape',
    categoryId: 'cat-1',
    categorySlug: 'zhongzhi-jishu',
    categoryName: '种植技术',
    author: '王明德',
    publishDate: '2026-07-28',
    readTime: 12,
    tags: ['高产栽培', '种植技术', '水肥管理', '品种选择'],
    viewCount: 12860,
    isFeatured: true,
  },
  {
    id: 'art-2',
    slug: 'huabei-xing-huangguo-pinzhong-tuijian',
    title: '华北型黄瓜品种推荐与栽培要点',
    summary: '详细介绍适合华北地区种植的优质黄瓜品种，包括津优35号、中农16号等主流品种的特性表现、产量水平及配套栽培技术。',
    content: `<p>华北地区是我国黄瓜主产区之一，气候特点是冬季寒冷干燥、夏季炎热多雨。选择适合该区域气候特点的黄瓜品种至关重要。</p>
<h2>华北型黄瓜品种特征</h2>
<p>华北型黄瓜果形细长，刺瘤密集，瓜把短，皮色深绿有光泽。具有耐低温弱光、早熟性好、产量高等特点，非常适合华北地区的保护地和露地栽培。</p>
<h2>推荐品种一：津优35号</h2>
<p>由天津科润黄瓜研究所育成的一代杂交种。植株长势强，主蔓结瓜为主，第一雌花节位3-4节。瓜条顺直，长35-38厘米，单瓜重200克左右。瓜皮深绿色，刺瘤中等，商品性极佳。早熟性好，从播种到始收约55天。抗霜霉病、白粉病能力强。亩产可达8000-10000公斤。</p>
<h2>推荐品种二：中农16号</h2>
<p>中国农业科学院蔬菜花卉研究所育成。中早熟品种，植株生长势中等，节间较短。瓜条长32-35厘米，瓜色亮绿，刺瘤适中。耐低温弱光，适合早春保护地栽培。连续坐瓜能力强，丰产性好。亩产约7000-9000公斤。</p>
<h2>推荐品种三：津春4号</h2>
<p>早熟杂交品种，耐低温性突出，适合日光温室越冬栽培。瓜条长30-33厘米，单瓜重180-200克。商品瓜率高，畸形瓜少。综合抗病性强。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Various%20Chinese%20cucumber%20varieties%20displayed%20on%20wooden%20surface%2C%20long%20green%20cucumbers%20with%20labels%2C%20agricultural%20product%20photography%2C%20clean%20white%20background%20with%20natural%20light%2C%20professional%20food%20styling&width=800&height=500&seq=art-cover-02&orientation=landscape',
    categoryId: 'cat-2',
    categorySlug: 'pinzhong-daiquan',
    categoryName: '品种大全',
    author: '李芳华',
    publishDate: '2026-07-25',
    readTime: 10,
    tags: ['华北型', '品种推荐', '津优35号', '中农16号'],
    viewCount: 9520,
    isFeatured: true,
  },
  {
    id: 'art-3',
    slug: 'huanggua-shuangmeibing-fangzhi-fangan',
    title: '黄瓜霜霉病综合防治方案',
    summary: '霜霉病是黄瓜生产中危害最严重的病害之一，本文详细介绍霜霉病的发病规律、识别特征以及化学防治与生物防治相结合的综合防控方案。',
    content: `<p>黄瓜霜霉病俗称"跑马干"，是黄瓜生产上发生最普遍、危害最严重的叶部病害。发病严重时可导致全田叶片枯死，造成严重减产甚至绝收。</p>
<h2>发病症状识别</h2>
<p>苗期和成株期均可发病，主要危害叶片。发病初期叶片正面出现淡黄色至黄色小斑点，扩大后受叶脉限制呈多角形病斑。潮湿条件下，病斑背面产生灰黑色霉层，即病原菌的孢囊梗和孢子囊。严重时多个病斑连片，叶片变黄枯死。</p>
<h2>发病规律</h2>
<p>病原菌为古巴假霜霉菌，属专性寄生菌。病菌以孢子囊随气流和水滴传播。发病适宜温度为16-24℃，相对湿度85%以上时发病迅速。棚室栽培中，昼夜温差大、结露时间长的情况下发病更重。</p>
<h2>综合防治措施</h2>
<h3>1. 农业防治</h3>
<p>选用抗病品种是防治霜霉病最经济有效的措施。合理密植，及时整枝打杈，改善通风透光条件。采用膜下滴灌，降低棚内湿度。雨后及时排水，防止田间积水。</p>
<h3>2. 生态防治</h3>
<p>保护地栽培中，通过调控温湿度抑制病害发生。晴天上午闭棚升温至30-32℃，然后通风排湿；下午适当通风，将夜间温度控制在12-15℃，减少叶面结露。</p>
<h3>3. 化学防治</h3>
<p>发病初期及时喷药防治。推荐药剂：68.75%氟菌·霜霉威悬浮剂600-800倍液、72%霜脲·锰锌可湿性粉剂600-800倍液、50%烯酰吗啉可湿性粉剂1500-2000倍液。每7-10天喷一次，连喷2-3次，注意轮换用药。</p>
<h3>4. 生物防治</h3>
<p>可选用枯草芽孢杆菌、木霉菌等生物制剂进行预防性喷施，减少化学农药使用量，生产绿色黄瓜产品。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cucumber%20leaf%20showing%20downy%20mildew%20disease%20symptoms%20with%20yellow%20spots%2C%20agricultural%20plant%20pathology%20closeup%2C%20scientific%20documentation%20style%2C%20clean%20neutral%20background%2C%20detailed%20macro%20photography&width=800&height=500&seq=art-cover-03&orientation=landscape',
    categoryId: 'cat-3',
    categorySlug: 'bingchonghai-fangzhi',
    categoryName: '病虫害防治',
    author: '张建国',
    publishDate: '2026-07-22',
    readTime: 8,
    tags: ['霜霉病', '病害防治', '综合防控', '农药使用'],
    viewCount: 11540,
    isFeatured: true,
  },
  {
    id: 'art-4',
    slug: '2026-nian-xiabanian-huangguo-jiage-zoushi-yuce',
    title: '2026年下半年黄瓜价格走势预测',
    summary: '基于全国主要批发市场上半年价格数据，结合种植面积、天气因素和消费趋势，对2026年下半年黄瓜市场价格走势进行专业分析与预测。',
    content: `<p>2026年上半年，全国黄瓜市场价格经历了先涨后落的波动走势。春节前后价格处于高位，3月份以后随着气温回升和供应量增加，价格逐步回落。展望下半年，黄瓜市场将呈现以下趋势：</p>
<h2>一、上半年价格回顾</h2>
<p>1-2月份，受春节消费拉动和冬季保护地生产成本较高影响，全国黄瓜批发均价维持在4.5-6.0元/公斤。3-5月份，随着山东、河北等主产区大棚黄瓜大量上市，价格回落至2.5-3.5元/公斤。6月份受南方高温多雨影响，部分产区减产，价格小幅回升。</p>
<h2>二、下半年影响因素分析</h2>
<p><strong>供给端：</strong>据农业农村部统计，2026年全国黄瓜种植面积较上年增加约5%。7-8月份是北方露地黄瓜集中上市期，供给量将明显增加。9月份以后，露地黄瓜逐渐减少，保护地黄瓜成为主要供应来源。</p>
<p><strong>需求端：</strong>下半年是黄瓜消费旺季，特别是7-9月高温季节，黄瓜作为清凉蔬菜消费量增加。中秋、国庆等节假日也将带动消费需求。</p>
<h2>三、价格走势预测</h2>
<p>7-8月份：价格维持低位运行，预计批发均价在2.0-3.0元/公斤。</p>
<p>9-10月份：受换季影响价格温和上涨，预计3.0-4.0元/公斤。</p>
<p>11-12月份：进入冬季保护地生产阶段，成本增加推动价格上涨，预计4.0-5.5元/公斤。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Fresh%20green%20cucumbers%20at%20wholesale%20agricultural%20market%20with%20price%20charts%20in%20background%2C%20busy%20vegetable%20trading%20scene%2C%20professional%20market%20analysis%20aesthetic%2C%20clean%20lighting%2C%20modern%20agricultural%20commerce&width=800&height=500&seq=art-cover-04&orientation=landscape',
    categoryId: 'cat-4',
    categorySlug: 'shichang-hangqing',
    categoryName: '市场行情',
    author: '陈明远',
    publishDate: '2026-07-20',
    readTime: 7,
    tags: ['价格走势', '市场预测', '行情分析', '批发价格'],
    viewCount: 18560,
    isFeatured: true,
  },
  {
    id: 'art-5',
    slug: 'huanggua-zhongzi-xuangou-zhinan',
    title: '黄瓜种子选购完全指南：如何选对种子种好瓜',
    summary: '面对市场上琳琅满目的黄瓜种子，种植户该如何科学选择？本文从品种特性、包装标识、品牌信誉等多维度出发，教您选购优质黄瓜种子。',
    content: `<p>种子是农业的"芯片"，选对种子是种好黄瓜的第一步。市场上黄瓜种子品牌繁多、品种繁杂，许多种植户在选购时感到困惑。</p>
<h2>一、看懂种子包装标识</h2>
<p>正规黄瓜种子包装上必须标注以下信息：品种名称、审定编号（或登记编号）、质量指标（纯度、净度、发芽率、水分）、生产日期、保质期、生产企业名称和地址等。购买时请仔细核对，避免购买到"三无"产品。</p>
<h2>二、根据栽培条件选择品种</h2>
<p>不同品种对栽培环境有不同要求。保护地越冬栽培应选择耐低温弱光的品种；春季大棚栽培选择早熟丰产品种；露地栽培则需要抗病耐热的品种。建议先了解品种的适应区域和栽培要点再做决定。</p>
<h2>三、关注品种抗病性</h2>
<p>黄瓜常见病害包括霜霉病、白粉病、枯萎病、病毒病等。选择具有复合抗病性的品种可以有效减少农药使用，降低生产成本。目前市场上多数优良品种对主要病害都有一定抗性。</p>
<h2>四、品牌推荐</h2>
<p>国内黄瓜种子企业品牌中，天津科润（津优系列）、中国农科院中蔬种业（中农系列）、北京京研益农等品牌信誉好、品种质量稳定。建议到正规种子门店或授权经销商处购买。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cucumber%20seed%20packets%20arranged%20on%20wooden%20desk%20with%20magnifying%20glass%2C%20agricultural%20seed%20selection%20guide%2C%20clean%20product%20photography%2C%20natural%20light%20from%20window%2C%20professional%20layout&width=800&height=500&seq=art-cover-05&orientation=landscape',
    categoryId: 'cat-5',
    categorySlug: 'zhongzi-xuangou',
    categoryName: '种子选购',
    author: '刘智慧',
    publishDate: '2026-07-18',
    readTime: 9,
    tags: ['种子选购', '品种选择', '品牌推荐', '购种指南'],
    viewCount: 8430,
    isFeatured: false,
  },
  {
    id: 'art-6',
    slug: 'huanggua-caihou-chuli-yu-baoxian-jishu',
    title: '黄瓜采后处理与保鲜储存关键技术',
    summary: '黄瓜采后损耗是制约产业发展的重要瓶颈。本文介绍黄瓜采后预冷、分级包装、冷链运输和保鲜储存等关键环节的技术要点与操作规范。',
    content: `<p>黄瓜含水量高、皮薄肉嫩，采后呼吸旺盛，极易失水萎蔫和腐烂变质。据统计，我国黄瓜采后损耗率高达20%-30%，采后处理技术亟待提升。</p>
<h2>一、适时采收</h2>
<p>黄瓜以嫩瓜供食，采收时间直接影响品质和耐贮性。一般开花后8-12天采收，瓜条达到品种固有长度和粗度时采收。采收宜在清晨或傍晚气温较低时进行，避免高温时段采收。</p>
<h2>二、预冷处理</h2>
<p>采后应尽快进行预冷处理，将瓜体温度降至10-12℃。推荐采用差压预冷或真空预冷方式，比自然冷却快5-10倍。预冷可有效降低黄瓜呼吸强度，延缓后熟衰老。</p>
<h2>三、分级包装</h2>
<p>预冷后进行分级挑选，剔除病虫瓜、畸形瓜和机械损伤瓜。按照瓜条长度、粗度和弯曲度等指标进行分级。包装材料选用透气性好的保鲜袋或保鲜膜，单层摆放避免挤压。</p>
<h2>四、冷链运输</h2>
<p>黄瓜运输推荐温度10-13℃，相对湿度90%-95%。短途运输可使用保温箱加冰袋；长途运输需使用冷藏车，全程控温。装车时轻拿轻放，避免机械损伤。</p>
<h2>五、保鲜储存</h2>
<p>黄瓜适宜储存条件：温度10-13℃，相对湿度90%-95%。低于10℃易发生冷害，高于15℃加速黄化衰老。家庭储存可用保鲜膜包裹后放入冰箱冷藏室蔬菜格，可保鲜5-7天。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cucumber%20cold%20storage%20facility%20with%20fresh%20green%20cucumbers%20in%20plastic%20crates%2C%20modern%20agricultural%20cold%20chain%20logistics%2C%20industrial%20food%20preservation%2C%20clean%20professional%20setting%2C%20cool%20blue%20tone%20lighting&width=800&height=500&seq=art-cover-06&orientation=landscape',
    categoryId: 'cat-6',
    categorySlug: 'jiagong-chucun',
    categoryName: '加工储存',
    author: '赵永康',
    publishDate: '2026-07-15',
    readTime: 8,
    tags: ['采后处理', '保鲜技术', '冷链运输', '储存方法'],
    viewCount: 6720,
    isFeatured: false,
  },
  {
    id: 'art-7',
    slug: 'dadeng-huangguo-dongji-zaipei-guanli',
    title: '大棚黄瓜冬季栽培管理关键技术',
    summary: '冬季是大棚黄瓜生产的关键期，温度低、光照弱、湿度大等不利因素对黄瓜生长构成严峻挑战。本文系统讲解冬季大棚黄瓜栽培管理核心技术。',
    content: `<p>冬季大棚黄瓜生产面临着低温、寡照、高湿等多重挑战。科学的管理技术是确保冬季黄瓜稳产高产的关键。</p>
<h2>一、温光调控</h2>
<p>温度管理是冬季黄瓜栽培的核心。晴天白天保持25-30℃，夜间15-18℃；阴雪天白天20-22℃，夜间12-15℃。采用多层覆盖保温，棚内加设小拱棚或二道幕。及时清扫棚膜积雪和灰尘，增加透光率。必要时安装补光灯，每天补充光照4-6小时。</p>
<h2>二、湿度管理</h2>
<p>冬季棚内湿度偏高是病害发生的主要原因。采用膜下滴灌，严格控制灌水量。晴天上午通风排湿，每次通风20-30分钟。畦面覆盖地膜或稻草减少地面蒸发。有条件的可安装除湿设备。</p>
<h2>三、水肥一体化</h2>
<p>冬季黄瓜需水量相对较少，遵循"见干见湿"原则。采用水肥一体化技术，将灌溉与施肥结合。追肥以高钾型水溶肥为主，配合腐殖酸、海藻酸等功能性肥料，促进根系生长和果实发育。</p>
<h2>四、植株管理</h2>
<p>及时吊蔓、落蔓，保持植株顶端平齐。适当疏瓜，每株同时留瓜2-3条，避免负载过重。及时摘除老叶、病叶和卷须，改善通风透光。采用熊蜂授粉或人工蘸花，提高坐瓜率。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cucumber%20greenhouse%20in%20winter%20with%20healthy%20vines%20growing%20on%20strings%2C%20modern%20plastic%20tunnel%20agriculture%2C%20warm%20interior%20lighting%2C%20professional%20farming%20scene%2C%20rows%20of%20green%20plants&width=800&height=500&seq=art-cover-07&orientation=landscape',
    categoryId: 'cat-1',
    categorySlug: 'zhongzhi-jishu',
    categoryName: '种植技术',
    author: '王明德',
    publishDate: '2026-07-12',
    readTime: 10,
    tags: ['大棚栽培', '冬季管理', '温光调控', '水肥一体化'],
    viewCount: 10120,
    isFeatured: false,
  },
  {
    id: 'art-8',
    slug: 'huanggua-baifenbing-shibie-yu-fangkong',
    title: '黄瓜白粉病识别与高效防控策略',
    summary: '白粉病是黄瓜生产中的常发性病害，尤其在保护地栽培中危害更为严重。本文详细讲解白粉病的识别方法、发病条件及高效防控措施。',
    content: `<p>黄瓜白粉病在保护地和露地栽培中均可发生，以保护地栽培危害更重。发病严重时，全株叶片布满白色粉状物，严重影响光合作用，造成减产降质。</p>
<h2>发病症状</h2>
<p>发病初期叶片正面出现白色近圆形小粉斑，后逐渐扩大连片，整叶布满白粉状物。后期白粉变为灰白色，叶片枯黄卷缩。叶柄和茎蔓也可受害，但症状不如叶片明显。</p>
<h2>发病条件</h2>
<p>白粉病菌喜温暖潮湿环境，发病适宜温度20-28℃，相对湿度80%以上时发病迅速。但不同于霜霉病，白粉病在干旱条件下也可发生。保护地栽培中，通风不良、光照不足有利于病害发生流行。</p>
<h2>防治措施</h2>
<p>农业防治：合理密植，科学整枝，改善通风透光；控制氮肥用量，增施磷钾肥；及时清除病残体。</p>
<p>化学防治：发病初期选用25%嘧菌酯悬浮剂1500倍液、10%苯醚甲环唑水分散粒剂1500倍液喷雾防治，7-10天一次，连喷2-3次。</p>
<p>生物防治：可使用蛇床子素、大黄素甲醚等植物源农药，或枯草芽孢杆菌等微生物制剂进行防治。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cucumber%20leaf%20with%20white%20powdery%20mildew%20disease%2C%20plant%20pathology%20closeup%20photography%2C%20agricultural%20disease%20identification%2C%20green%20leaf%20with%20white%20spots%2C%20scientific%20documentation%20style%2C%20clean%20background&width=800&height=500&seq=art-cover-08&orientation=landscape',
    categoryId: 'cat-3',
    categorySlug: 'bingchonghai-fangzhi',
    categoryName: '病虫害防治',
    author: '张建国',
    publishDate: '2026-07-10',
    readTime: 7,
    tags: ['白粉病', '病害识别', '防治策略', '农药使用'],
    viewCount: 7890,
    isFeatured: false,
  },
  {
    id: 'art-9',
    slug: 'shandong-shouguang-huangguo-jiage-hangqing',
    title: '山东寿光黄瓜批发价格周报（7月第4周）',
    summary: '本周寿光农产品物流园黄瓜批发价格稳中有降，优质黄瓜批发价2.8-3.5元/公斤，普通黄瓜2.0-2.6元/公斤，上市量较上周增加约15%。',
    content: `<p>本周（7月22日-7月28日），山东寿光农产品物流园黄瓜批发价格整体稳中有降。</p>
<h2>价格详情</h2>
<p>优质黄瓜（条直、无病虫害、包装规范）批发价2.8-3.5元/公斤，较上周下降约0.3元/公斤。</p>
<p>普通黄瓜批发价2.0-2.6元/公斤，与上周基本持平。</p>
<p>小黄瓜（水果黄瓜）批发价5.0-7.0元/公斤，价格较为坚挺。</p>
<h2>市场分析</h2>
<p>本周寿光本地及周边产区大棚黄瓜进入盛产期，上市量较上周增加约15%。加之河北、辽宁等北方产区露地黄瓜大量上市，市场供应充足，价格承压下行。</p>
<h2>后市展望</h2>
<p>预计下周黄瓜价格将继续维持低位运行。建议种植户合理安排采收和销售节奏，有储存条件的可适当延迟销售。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Shouguang%20vegetable%20wholesale%20market%20with%20cucumber%20trading%20stalls%2C%20busy%20agricultural%20commerce%20scene%2C%20large%20piles%20of%20fresh%20green%20cucumbers%2C%20professional%20market%20photography%2C%20natural%20daylight&width=800&height=500&seq=art-cover-09&orientation=landscape',
    categoryId: 'cat-4',
    categorySlug: 'shichang-hangqing',
    categoryName: '市场行情',
    author: '陈明远',
    publishDate: '2026-07-08',
    readTime: 5,
    tags: ['寿光', '批发价格', '价格周报', '市场行情'],
    viewCount: 15620,
    isFeatured: false,
  },
  {
    id: 'art-10',
    slug: 'ouzou-wenshi-huangguo-pinzhong-jieshao',
    title: '欧洲温室型黄瓜品种介绍及引进前景',
    summary: '欧洲温室型黄瓜具有无刺、皮薄、味甜等特点，在国内高端市场越来越受欢迎。本文介绍主要欧洲温室黄瓜品种特性及在国内的引种栽培前景。',
    content: `<p>欧洲温室型黄瓜（又称无刺黄瓜、荷兰黄瓜）近年来在国内市场逐渐走俏，尤其受到高端超市和电商平台的青睐。</p>
<h2>品种特性</h2>
<p>欧洲温室型黄瓜果皮光滑无刺，瓜条长30-40厘米，单瓜重250-400克。皮薄肉厚，口感脆嫩微甜，适合生食沙拉。植株为无限生长型，单性结实能力强，无需授粉即可坐瓜。</p>
<h2>主要品种</h2>
<p>1. 戴多星（Dedos）：荷兰瑞克斯旺公司品种，早熟高产，瓜条深绿色有光泽，品质优异。</p>
<p>2. 碧玉（Picowell）：德国品种，瓜条均匀整齐，耐储运性好，货架期长。</p>
<p>3. 萨菲（Safir）：适合有机栽培，抗病性强，对白粉病和霜霉病有较好抗性。</p>
<h2>引种前景</h2>
<p>随着消费升级，国内对高品质无刺黄瓜的需求持续增长。建议有条件的种植基地可引进试种，重点面向高端商超和电商渠道销售，经济效益显著高于普通黄瓜品种。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=European%20greenhouse%20cucumbers%20smooth%20skin%20long%20variety%20on%20modern%20display%2C%20high%20end%20vegetable%20photography%2C%20Dutch%20cucumber%20style%2C%20clean%20white%20background%2C%20professional%20food%20styling%20with%20soft%20lighting&width=800&height=500&seq=art-cover-10&orientation=landscape',
    categoryId: 'cat-2',
    categorySlug: 'pinzhong-daiquan',
    categoryName: '品种大全',
    author: '李芳华',
    publishDate: '2026-07-05',
    readTime: 8,
    tags: ['欧洲品种', '温室黄瓜', '品种引进', '高端市场'],
    viewCount: 6210,
    isFeatured: false,
  },
];

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.categorySlug === categorySlug);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.isFeatured);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getRelatedArticles(article: Article, limit: number = 3): Article[] {
  return articles
    .filter((a) => a.id !== article.id && a.categoryId === article.categoryId)
    .slice(0, limit);
}